import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISummaryReport, ResponsibleType } from '@shared/interfaces';
import { SummaryReportService } from '@shared/services';
import { FileService } from '@shared/services/file.service';
import { GuardService } from '@shared/services/guard.service';

@Component({
    selector: 'app-summary-report-tile',
    templateUrl: './summary-report-tile.component.html',
    styleUrls: ['./summary-report-tile.component.scss'],
    standalone: false
})
export class SummaryReportTileComponent {
    @Input() item: ISummaryReport;
    @Output() delete = new EventEmitter();
    @Input() isPlaceholder: boolean;
    @Input() isPlaceholderLight: boolean;
    @Input() auto: boolean;
    @Input() delay = 0;

    isSaving: boolean;

    constructor(
        private readonly summaryReportService: SummaryReportService,
        private fileService: FileService,
        public guard: GuardService
    ) {}

    get responsibleType(): string {
        return this.item ? (this.item.responsibleType === ResponsibleType.sag ? 'sag' : 'rc') : '';
    }

    async handleItem() {
        if (this.item && !this.isSaving) {
            this.isSaving = true;
            try {
                const document = await this.summaryReportService.getDownloadLink(this.item.id);
                const fileName = `${this.item.title}`.replace(new RegExp(' ', 'g'), '_');
                await this.fileService.downloadAttachment(document, fileName + '.pdf');
            } catch (e) {
                console.error(e.message);
            }
            this.isSaving = false;
        }
    }
}
